// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3a3iu","buttons":"SendReceipts_buttons__s0-qw","email":"SendReceipts_email__3rna5","bookApptTitle":"SendReceipts_bookApptTitle__gkBog"};